import {qspost} from '@/plugins/axios'

/*
 * 添加编辑题目分类
 * @constructor jack
 * */
export const updateQuestionCate = (name, icon,id) => qspost('/Index/Question/updateQuestionCate', {name, icon,id})

/*
 * 题目分类列表
 * @constructor jack
 * */
export const questionCateList = (keyword, page,pageSize,startTime='',endTime='') => qspost('/Index/Question/questionCateList', {keyword, page,pageSize,startTime,endTime})

/*
 * 题目分类详情
 * @constructor jack
 * */
export const questionCateDetail = (id) => qspost('/Index/Question/questionCateDetail', { id})

/*
 * 删除题目分类
 * @constructor jack
 * */
export const delQuestionCate = (id) => qspost('/Index/Question/delQuestionCate', { id})

/*
 * 添加编辑题目
 * @constructor jack
 * */
export const updateQuestion = (type,cate_ids,question,option,answer,analysis,id='') => qspost('/Index/Question/updateQuestion', { type,cate_ids,question,option,answer,analysis,id})

/*
 * 题目列表
 * @constructor jack
 * */
export const questionList = (keyword,cate_ids, page,pageSize,startTime='',endTime='') => qspost('/Index/Question/questionList', {keyword, cate_ids,page,pageSize,startTime,endTime})

/*
 * 题目详情
 * @constructor jack
 * */
export const questionDetail = (id) => qspost('/Index/Question/questionDetail', { id})

/*
 * 删除题目
 * @constructor jack
 * */
export const delQuestion = (id) => qspost('/Index/Question/delQuestion', { id})

/*
 * 显示隐藏题目
 * @constructor jack
 * */
export const setShowQuestion = (is_show,id) => qspost('/Index/Question/setShowQuestion', { is_show,id})

/*
 * 添加编辑竞赛
 * @constructor jack
 * */
export const updateQuestionRace = (name,answer_min,sort_time,race_start_time,race_end_time,cate_ids,question_num,join_users,race_rule,id='') => qspost('/Index/Question/updateQuestionRace', { name,answer_min,sort_time,race_start_time,race_end_time,cate_ids,question_num,join_users,race_rule,id})

/*
 * 竞赛列表
 * @constructor jack
 * */
export const questionRaceList = (keyword, page,pageSize,startTime='',endTime='') => qspost('/Index/Question/questionRaceList', {keyword, page,pageSize,startTime,endTime})

/*
 * 竞赛详情
 * @constructor jack
 * */
export const QuestionRaceDetail = (id) => qspost('/Index/Question/QuestionRaceDetail', { id})

/*
 * 删除竞赛
 * @constructor jack
 * */
export const delQuestionRace = (id) => qspost('/Index/Question/delQuestionRace', { id})

/*
 * 竞赛排名
 * @constructor jack
 * */
export const getRaceRankingById = (id,user_type,searchName,searchPhone,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId) => qspost('/Index/Question/getRaceRankingById', { id,user_type,searchName,searchPhone,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId})





/*
 * 显示隐藏竞赛
 * @constructor jack
 * */
export const setShowQuestionRace = (is_show,id) => qspost('/Index/Question/setShowQuestionRace', { is_show,id})

/*
 * 根据分类获取可用题目
 * @constructor jack
 * */
export const getQuestionNumByCate = (cate_ids) => qspost('/Index/Question/getQuestionNumByCate', { cate_ids})


/*
 * 添加编辑图文视频
 * @constructor jack
 * */
export const updateArticleVideo = (title,cate_ids,desc,content,image,video_url,type,id) => qspost('/Index/Question/updateArticleVideo', { title,cate_ids,desc,content,image,video_url,type,id})

/*
 * 图文视频列表
 * @constructor jack
 * */
export const articleVideoList = (type,keyword,cate_ids, page,pageSize,startTime='',endTime='') => qspost('/Index/Question/articleVideoList', {type,keyword, cate_ids,page,pageSize,startTime,endTime})

/*
 * 图文视频详情
 * @constructor jack
 * */
export const articleVideoDetail = (id) => qspost('/Index/Question/articleVideoDetail', { id})

/*
 * 删除图文视频
 * @constructor jack
 * */
export const delArticleVideo = (id) => qspost('/Index/Question/delArticleVideo', { id})


/*
 * 删除图文视频
 * @constructor jack
 * */
export const setShowArticleVideo = (is_show,id) => qspost('/Index/Question/setShowArticleVideo', { is_show,id})

/*
 * 系统排名
 * @constructor jack
 * */
export const getSystemRanking = (user_type,searchName,searchPhone,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId) => qspost('/Index/Question/getSystemRanking', { user_type,searchName,searchPhone,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId})

